import { render, staticRenderFns } from "./info-stats-meta.vue?vue&type=template&id=638ee67d&scoped=true"
import script from "./info-stats-meta.vue?vue&type=script&lang=ts"
export * from "./info-stats-meta.vue?vue&type=script&lang=ts"
import style0 from "./info-stats-meta.vue?vue&type=style&index=0&id=638ee67d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638ee67d",
  null
  
)

export default component.exports